export default __webpack_public_path__ + "static/media/logo_full.f7e24cde.svg";